import { CONTRACT_AUCTION, CONTRACT_MARKET } from 'config/constants'

export const compactAddress = (address: string) => {
  if (address) {
    return `${address.substring(0, 4)}...${address.substring(address.length - 4)}`
  }

  return null
}

export const formatCode = (text: string, start: number, end: number, concat = '...') => {
  if (!text) return text
  if (text.toLowerCase() === CONTRACT_MARKET.toLowerCase())
    return (
      <p style={{ color: 'gray' }}>
        <img width="13px" style={{ display: 'inline-block', marginTop: '-2px' }} src="/logo.png" alt="" /> SOEI Spot
        Contract
      </p>
    )
  if (text.toLowerCase() === CONTRACT_AUCTION.toLowerCase())
    return (
      <p style={{ color: 'gray' }}>
        <img width="13px" style={{ display: 'inline-block', marginTop: '-2px' }} src="/logo.png" alt="" /> SOEI Auction
        Contract
      </p>
    )
  if (text.toLowerCase() === '0x0000000000000000000000000000000000000000'.toLowerCase())
    return (
      <p style={{ color: 'gray' }}>
        <img width="13px" style={{ display: 'inline-block', marginTop: '-2px' }} src="/logo.png" alt="" /> SOEI Create
        Contract
      </p>
    )
  const total = start + end
  const { length } = text
  if (total >= length) {
    return text
  }
  return [text.slice(0, start), text.slice(length - end)].join(concat)
}
